import kebabCase from 'hs-lodash/kebabCase';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from '../signup-data/DATA';
import { getSignupDataValue } from '../store/signup-data/selectors';
export const checkCompanySizeIsLessThan5 = companySize => {
  return companySize === CompanySizeOption.One || companySize === CompanySizeOption.TwoToFive;
};
export const getPresetOptionalDomain = companyName => {
  const cleanedCompanyName = kebabCase(companyName);
  return `${cleanedCompanyName}-hubspot-freecmstools.com`;
};
export const hasPresetOptionalDomain = state => {
  const companyName = getSignupDataValue(state, Data.CompanyName);
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const optionalDomain = getPresetOptionalDomain(companyName);
  return optionalDomain === companyDomain;
};